import React, { useEffect } from 'react';
import styled from 'styled-components';
import { scroller } from 'react-scroll';

import { Flex } from '../atom/Layout';
import FloatingButton from '../molecules/FloatingButton';
import { SubHeader } from '../organism/SubHeader';
import Header from '../organism/Header';
import Footer from '../organism/Footer';
import Modal from '../organism/Modal';
import DeliveryModal from '../organism/DeliveryModal';
import PCLeftBanner from '../organism/PCLeftBanner';
import PCBackground from '../organism/PCBackground';

import { breakpoint, SizeToRem } from '../../../lib/style/ThemeStyle';
import PromotionModal from '../organism/PromotionModal';

const PageTemplate = ({ children, title, noMargin }) => {
  useEffect(() => {
    const { hash } = window.location;
    if (hash !== '') {
      setTimeout(() => {
        scroller.scrollTo(hash.substring(1), {
          spy: true,
          smooth: false,
          duration: 500,
          offset: -120
        });
      }, 1000)
    }
  }, []);
  
  return (
    <>
      <PromotionModal />
      <Page>
        <PCBackground />
        <PCLeftBanner />
        <MainContainer role="main">
          <Header />
          {title && <SubHeader title={title} />}
          <PageLayout noMargin={noMargin} withSubTitle={title}>
            {children}
          </PageLayout>
          <Footer />
          <Modal />
          <DeliveryModal />
        </MainContainer>
        <FloatingButton />
      </Page>
    </>
  );
};

export default PageTemplate;

const Page = styled(Flex)`
  background: #fcf6f9;
`;

const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${breakpoint}px;
  min-height: 100vh;
  background: ${({ theme }) => theme.background.white};
  z-index: 1;
`;

const PageLayout = styled.section`
  width: inherit;
  background: #ffffff;
  margin-top: ${(props) => (!props.withSubTitle ? '2.875rem' : '5.625rem')};
  padding: ${(props) => (props.noMargin ? 0 : SizeToRem(20))};
`;
